import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

import { PlaidLink } from 'react-plaid-link';
import configs from '../../configs/environments';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import termsText from './achAccountLinkTermsAndConditionsText';

import confirmationDialogStyles from '../confirmation/confirmationDialog.module.css';

const styles = (theme: Theme) =>

  createStyles({
    btn: {
      margin: '10px 10px'
    },
    ex: {
      padding: 0
    },
    button: {
      height: '50px',
      marginTop: '14px'
    }
  });

interface AchAccountLinkTermsAndConditionsModalProps  {
  classes: any;
  openModal: boolean;
  closeModal: () => void;
  onSuccess: (token: string, metadata: any) => void;
};

class AchAccountLinkTermsAndConditionsModal extends Component <AchAccountLinkTermsAndConditionsModalProps, {}> {

  render() {

    const { classes } = this.props;

    return (
      <Dialog
        open={ this.props.openModal }
        maxWidth={ "lg" }
        onClose={ this.props.closeModal }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick={ true }
        disableEscapeKeyDown={ true }
      >
      <div className={ confirmationDialogStyles.flex }>
        <DialogTitle id="alert-dialog-title">{ "Terms and conditions" }</DialogTitle>
      </div>

      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ textAlign: 'justify' }}><ReactMarkdown source={ termsText } /></DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button className={ classes.btn } onClick={ this.props.closeModal } variant="contained">{ "Cancel" }</Button>
        <PlaidLink
          clientName="TryPod"
          style={ {
              color: '#fff',
              backgroundColor: 'var(--primaryblue)',
              cursor: 'pointer',
              lineHeight: 1.75,
              padding: '6.5px 20px',
              fontSize: '0.875rem',
              minWidth: '64px',
              boxSizing: 'border-box',
              boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
              transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 500,
              borderRadius: '4px',
              letterSpacing: '0.02857em',
              textTransform: 'uppercase',
              border: 'none'
            } }
          env={ configs.plaidEnv }
          product={['auth', 'transactions']}
          publicKey={ configs.plaidKey }
          onSuccess={ this.props.onSuccess }
          onExit={ this.props.closeModal }
        >
          Agree
        </PlaidLink>;
      </DialogActions>

    </Dialog>
    );
  }
};

export default withStyles(styles)(AchAccountLinkTermsAndConditionsModal);